import { render } from "./SeriesDetails.vue?vue&type=template&id=e51c8334&scoped=true"
import script from "./SeriesDetails.vue?vue&type=script&lang=js"
export * from "./SeriesDetails.vue?vue&type=script&lang=js"

import "./detailsCard.css?vue&type=style&index=0&id=e51c8334&scoped=true&lang=css&external"
import "./SeriesDetails.vue?vue&type=style&index=1&id=e51c8334&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e51c8334"]])

export default __exports__